export enum UserGroup {
  VIEW_ONLY = "View Only",
  EPR_ADMIN = "EPR Admin",
  EPR_DEV_OPS = "EPR Dev-Ops",
  REPORTING_RESPONSIBLE = "Reporting Responsible",
  CUSTOMER_ACCOUNT_MANAGER = "Customer Account Manager",
  EXTERNAL_USER = "External User"
}
